import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { LanguageService } from '@spartacus/core'
import { Subscription } from 'rxjs'

@Component({
    selector: 'eb-date-picker',
    templateUrl: './eb-date-picker.component.html',
    styleUrls: ['./eb-date-picker.component.scss'],
    standalone: false
})
export class EbDatePickerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() minDate
  @Input() startDate
  @Input() disableDays
  @Input() hideInput: boolean
  @Input() showDelete: boolean
  @Input() hideEditLabel: boolean
  @Input() isLoading = false

  @Output() dateChange = new EventEmitter<Date>()

  pickerMinDate: any
  selectedDate: any
  navigation: 'arrows'

  subscriptions = new Subscription()
  render = true

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.selectedDate = this.getInitDate(this.startDate)
    this.pickerMinDate = this.getInitDate(this.minDate)
    this.subscriptions.add(
      this.languageService.getActive().subscribe(locale => {
        this.render = false
        this.cd.detectChanges()
        requestAnimationFrame(() => {
          this.render = true
          try {
            // because of intermediate ngOnDestroy
            this.cd.detectChanges()
          } catch (e) {}
        })
      })
    )
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.date) {
      if (changes.date?.currentValue) {
        const newDate = changes.date.currentValue as Date
        this.selectedDate = {
          year: newDate.getFullYear(),
          month: newDate.getMonth() + 1,
          day: newDate.getDate()
        }
      }
      this.cd.detectChanges()
    }
  }

  getInitDate(date: Date) {
    const initDate = date ? date : new Date(Date.now())
    return {
      year: initDate.getFullYear(),
      month: initDate.getMonth() + 1,
      day: initDate.getDate()
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
